import React, { useState } from 'react'
import { motion, AnimatePresence } from 'framer-motion'
import Terms from './Terms.jsx'
import Privacy from './Privacy.jsx'
import Contact from './Contact.jsx'
import CookiePolicy from './CookiePolicy.jsx'
import { X } from 'lucide-react'
import { useT } from '@/context/TranslateCtx'

const backdrop = {
  hidden: { opacity: 0 },
  visible: { opacity: 1, transition: { duration: 0.2 } },
  exit: { opacity: 0, transition: { duration: 0.2 } }
}

const panel = {
  hidden: { scale: 0.85, opacity: 0 },
  visible: { scale: 1, opacity: 1, transition: { type: 'spring', stiffness: 180, damping: 22 } },
  exit: { scale: 0.9, opacity: 0, transition: { duration: 0.2 } }
}

export default function Footer() {
  const { t } = useT()
  const [modalName, setModalName] = useState(null)
  const close = () => setModalName(null)

  return (
    <>
      <footer className="bg-gray-900 text-white py-10">
        <div className="container flex flex-col md:flex-row items-center justify-between gap-8">
          <div className="text-center md:text-left">
            <h3 className="text-2xl md:text-3xl font-bold">Kuizy.ai</h3>
            <p className="text-sm md:text-base opacity-75">© {new Date().getFullYear()} Kuizy.ai · {t('footer.copyright')}</p>
          </div>
          <div className="flex flex-col sm:flex-row items-center gap-6 text-sm md:text-base">
            <button onClick={() => setModalName('privacy')} className="hover:text-primary">{t('footer.privacy')}</button>
            <button onClick={() => setModalName('cookie')} className="hover:text-primary">{t('footer.cookie')}</button>
            <button onClick={() => setModalName('terms')} className="hover:text-primary">{t('footer.terms')}</button>
            <button onClick={() => setModalName('contact')} className="hover:text-primary">{t('footer.contact')}</button>
          </div>
        </div>
      </footer>

      <AnimatePresence>
        {modalName && (
          <motion.div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-sm" variants={backdrop} initial="hidden" animate="visible" exit="exit">
            <motion.div className="relative bg-white rounded-2xl max-w-5xl w-[92%] md:w-[80%] max-h-[88vh] overflow-y-auto p-10" variants={panel}>
              {modalName === 'contact' && (
                <button onClick={close} className="fixed top-6 right-6 bg-white/80 backdrop-blur p-3 rounded-full shadow-lg hover:bg-white">
                  <X size={28} />
                </button>
              )}
              {modalName === 'privacy' && <Privacy onClose={close} />}
              {modalName === 'cookie' && <CookiePolicy onClose={close} />}
              {modalName === 'terms' && <Terms onClose={close} />}
              {modalName === 'contact' && <Contact onClose={close} />}
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  )
}
